import React, { useEffect, useRef, useState }  from 'react';
import { Button, Input, Space, Table, Modal, Tooltip, message } from 'antd';
import { SearchOutlined, EyeOutlined } from '@ant-design/icons';
import { formateBusesBusidasKey } from './vechicle-management.module';
import { isValid } from "../../utils/utilities";
import { getSeatLayOut } from '../../actions/admin.action';
import { SeatLayoutContainer } from '../seat-layout/seat-layout-container.component';

export const VechicleManagementTable = (props) => {

  const {
    vehicles,
    busesData,
    updateFormData,
    formData
  } = props;

  const [busesWithIdasKey , setBusesWithIdAsKey]=useState({});
  const searchInputRef = useRef(null);

  const [seatLayoutModalOpen, setSeatLayoutModalOpen] = useState(false);
  const [seatLayoutData, setSeatLayoutData] = useState([]);
  const [activeBusId, setActiveBusId] = useState(null);

  useEffect(()=>{
      setBusesWithIdAsKey(formateBusesBusidasKey(busesData));
  },[busesData]);

  const openSeatLayout = (busId) => {
    if(!isValid(busId)) return;
    setActiveBusId(busId);
    getSeatLayOut(busId, (data) => {
      const layout = isValid(data) && isValid(data.seat_layout) ? data.seat_layout : [];
      if(layout.length === 0){
        message.info('No seat layout available for this bus');
        return;
      }
      setSeatLayoutData(layout);
      setSeatLayoutModalOpen(true);
    }, () => {
      message.error('Failed to fetch seat layout');
    });
  };

  const getVehicleNoSearchProps = () => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div className="vehicle-no-filter-dropdown" onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInputRef}
          placeholder="Search vehicle no"
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
        />
        <Space>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            size="small"
            onClick={() => confirm()}
          >
            Search
          </Button>
          <Button
            size="small"
            onClick={() => {
              if (clearFilters) {
                clearFilters();
              }
              confirm();
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const vehicleNo = record && record.vechicle_no ? String(record.vechicle_no).toLowerCase() : "";
      return vehicleNo.includes(String(value).toLowerCase());
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current && searchInputRef.current.select(), 100);
      }
    }
  });

  const columns= [
    {
      title: 'Bus Description',
      dataIndex: 'bus_id',
      key: 'bus_id',
      render: (text, record) => (
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          <span>
            { isValid(busesWithIdasKey)&&isValid(busesWithIdasKey[text])?busesWithIdasKey[text].description:""}
          </span>
          <Tooltip title="View Seat Layout">
            <EyeOutlined
              style={{ color: '#c99a2e', cursor: 'pointer', fontSize: 18, marginLeft: 8 }}
              onClick={(e) => {
                e.stopPropagation();
                openSeatLayout(record.bus_id);
              }}
            />
          </Tooltip>
        </span>
      )
    },
    {
      title: 'Vehicle No',
      dataIndex: 'vechicle_no',
      key: "vechicle_no",
      ...getVehicleNoSearchProps()
    }
  ];

  return (
    <div>
      <Table
        dataSource={vehicles}
        columns={columns}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              updateFormData(record);
            }
          };
        }}
        rowClassName={(record, index)=>{
          let rowClassName="";
          if(record.id== formData.id){
              rowClassName=rowClassName+" TableRowClicked"
          }
          return  rowClassName
        }}
      />

      <Modal
        title="Seat Layout"
        visible={seatLayoutModalOpen}
        onCancel={() => setSeatLayoutModalOpen(false)}
        footer={null}
        width="95%"
        style={{ maxWidth: 900 }}
        destroyOnClose={true}
      >
        <div style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto' }}>
          <SeatLayoutContainer
            key={activeBusId}
            seatsData={seatLayoutData}
            showLegend={false}
            showFarePopOver={false}
            blockedSeatAllowed={false}
            noOfSeatsAllowedToClick={0}
            isDragDropRequired={false}
          />
        </div>
      </Modal>
    </div>
  );
}
